import React from 'react';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import '../style/Product.css';
import Sidebar from '../components/Sidebar';
import { db, auth } from '../firebase';

 
const products = [

{
  "id": 1,
  "name": "Mailer Bag",
  "images": ["190GSMWhite.jpg"],
  "BASE_COST": 235,
  "tax": "tax",
  "mockups": ["190GSMWhite.jpg"],
  "costStructure": {
    "DTF Epson": {
      "logo": 36,
      "LessthenA4": 66,
      "A4less": 102,
      "A4": 90,
      "A3": 120,
      "full": 150
    }
  },
},


{
  "id": 2,
  "name": "Thank You Card",
  "images": ["190GSMWhite.jpg", "190GSMWhiteB.jpg"],
  "BASE_COST": 235,
  "tax": "tax",
  "mockups": ["190GSMWhite.jpg", "190GSMWhiteB.jpg"],
  "costStructure": {
    "DTF Epson": {
      "logo": 36,
      "LessthenA4": 66,
      "A4less": 102,
      "A4": 90,
      "A3": 120,
      "full": 150
    }
  },
  "clippingRects": {
    "front": { "left": 540, "top": 690, "width": 1120, "height": 1400 },
    "back": { "left": 540, "top": 690, "width": 1120, "height": 1400 }
  }
},


{
  "id": 3,
  "name": "Hang Tag",
  "images": ["190GSMWhite.jpg", "190GSMWhiteB.jpg"],
  "BASE_COST": 235,
  "tax": "tax",
  "mockups": ["190GSMWhite.jpg", "190GSMWhiteB.jpg"],
  "costStructure": {
    "DTF Epson": {
      "logo": 36,
      "LessthenA4": 66,
      "A4less": 102,
      "A4": 90,
      "A3": 120,
      "full": 150
    }
  },
  "clippingRects": {
    "front": { "left": 540, "top": 690, "width": 1120, "height": 1400 },
    "back": { "left": 540, "top": 690, "width": 1120, "height": 1400 }
  }
},

{
  "id": 4,
  "name": "Stickers",
  "images": ["190GSMWhite.jpg", "190GSMWhiteB.jpg"],
  "BASE_COST": 235,
  "tax": "tax",
  "mockups": ["190GSMWhite.jpg", "190GSMWhiteB.jpg"],
  "costStructure": {
    "DTF Epson": {
      "logo": 36,
      "LessthenA4": 66,
      "A4less": 102,
      "A4": 90,
      "A3": 120,
      "full": 150
    }
  },
  "clippingRects": {
    "front": { "left": 540, "top": 690, "width": 1120, "height": 1400 },
    "back": { "left": 540, "top": 690, "width": 1120, "height": 1400 }
  }
} 
];


const SelectBranding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const shop = queryParams.get('shop');
  const state = location.state;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);


  const user = auth.currentUser;
  if (!user) {
    throw new Error("User not logged in");
  }


  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleProductClick = (product) => {
    // Check if the product is joggers and route accordingly
    if (product.productType === 'joggers') {
      navigate('/DesignJoggers', { 
        state: { 
          product, 
          costStructure: product.costStructure, 
          BASE_COST: product.BASE_COST, 
          name: product.name, 
          GSM: product.GSM, 
          tax: product.tax,
          clippingRects: product.clippingRects, 
          sizeChart: product.sizeChart, 
          print_method: product.print_method, 
          sizes: product.sizes 
        } 
      });
    } else {
      // Default route for t-shirts and other products
      navigate('/design-branding', { 
        state: { 
          product, 
          costStructure: product.costStructure, 
          BASE_COST: product.BASE_COST, 
          name: product.name, 
          GSM: product.GSM, 
          tax: product.tax,
          clippingRects: product.clippingRects, 
          sizeChart: product.sizeChart, 
          print_method: product.print_method, 
          sizes: product.sizes 
        } 
      });
    }
  };

  return (
    <div className="dashboard">
      <Header />
      <div className="dashboard-container">
        <Sidebar />
        <div className="main-content">
          <div className="product-list">
            {products.map((product) => (
              <div
                key={product.id}
                className="product-card"
                onClick={() => handleProductClick(product)}
              >
                <img src={product.images[0]} alt={product.name} className="product-image" />
                <p className="product-description">{product.name}</p>
                <p className="product-description">{product.fabric}</p>
                <p className="product-description">Base Cost: ₹{product.BASE_COST} + {product.tax} </p>
                <p className="product-description">{product.GSM}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectBranding;